import BaseWidgetProvider from './base/BaseWidgetProvider'
import ImageLogoGreenSmall from '../../../images/LogoGreenSmall.png'
import ImageIcon from '@mui/icons-material/Image'

const WidgetImage = ({ data }) => {
  return (
    <div
      style={{
        flexGrow: 1,
        width: '100%',
        height: '100%',
        backgroundImage: `url(${data?.imgSrc})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: data?.fit ? data.fit : 'contain'
      }}
    />
  )
}

class WidgetImageProvider extends BaseWidgetProvider {
  getCode = () => 'WidgetImageProvider'

  getName = () => 'Url image'

  createWidget = (props) => <WidgetImage {...props} />

  getIcon = () => ImageIcon

  getWidgetInfo = (columns, cellHeight) => {
    return { ...super.getWidgetInfo(columns, cellHeight), availableWithoutDevice: true, hideHeader: true }
  }

  getConfigurationInfo = () => {
    return [
      {
        key: 'imgSrc',
        type: 'text',
        label: 'Image url',
        defaultValue: ImageLogoGreenSmall
      },
      {
        key: 'fit',
        type: 'select',
        label: 'Image fit',
        defaultValue: 'contain',
        selectableOptions: ['fill', 'cover', 'scale-down', 'contain']
      }
    ]
  }
}

export default WidgetImageProvider
